import { createRouter, createWebHistory } from 'vue-router';
import Home from '@/views/Home.vue';
import About from '@/views/About.vue';
import Axios from "axios";
import { useCookies } from 'vue3-cookies';

const routes = [
  {
    path: '/',
    name: 'Home',
    redirect: "/home"
  },
  {
    path: '/home',
    name: 'Home',
    component: Home
  },
  {
    path: '/about',
    name: 'About',
    component: About
  },
  {
    path: '',
    redirect: '/home'
  },
  {
    path: '/login',
    name: 'Auth',
    component: () => import('../components/Auth.vue')
  },
  {
    path: '/list',
    name: 'List',
    component: () => import('../views/List.vue')
  },
  {
    path: '/listing-sessions',
    name: 'Sessions',
    component: () => import('../views/ListingSessions.vue')
  },
  {
    path: '/inventory',
    name: 'Inventory',
    component: () => import('../views/Inventory.vue')
  },
  {
    path: '/sales',
    redirect: '/sales/dashboard'
  },
  {
    path: '/sales/import-and-review',
    name: 'SalesImportAndReview',
    component: () => import('../views/Sales.vue')
  },
  {
    path: '/sales/dashboard',
    name: 'SalesDashboard',
    component: () => import('../views/SalesDashboard.vue')
  },
  {
    path: '/settings',
    name: 'Settings',
    component: () => import('../views/AccountSettings.vue')
  },
  {
    path: '/images',
    name: 'Images',
    component: () => import('../views/Images.vue')
  }
];

const router = createRouter({
  history: createWebHistory(process.env.VUE_APP_BASE_URL || '/'),
  routes
});

// Router guards and Axios integration
router.beforeEach((to, from, next) => {
  const publicPages = ['/login', '/about'];
  const authRequired = !publicPages.includes(to.path);

  const { cookies } = useCookies();
  const token = localStorage.getItem('token') || cookies.get('token');

  if (authRequired && !token) {
    const redirectUrl = to.fullPath;
    next({ path: '/login', query: redirectUrl ? { redirectUrl } : {} });
  } else {
    if (token) {
      Axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
    } else {
      delete Axios.defaults.headers.common['Authorization'];
    }
    next();
  }
});

export default router;
